// extracted by mini-css-extract-plugin
module.exports = {"container":"lock-avatar__container___1sBc-"};